module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 114 36",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }